import { api } from './http'

// Cliente del endpoint DataTables server-side de Qualita: GET /{resource}/datatables.
// Pagina, filtra y ordena EN EL BACKEND (solo trae la página). ~10x más rápido que view=BaseList
// para tablas grandes (comprobanteventa: 549ms vs 5296ms para 2586 filas).
//
// Contrato (verificado en vivo 2026-06-25):
//   - `search` = JSON del filtro base obligatorio (and([{path,equals|notEquals|...}])).
//   - `columns[i][data|search[value]|type]` = columnas; el search[value] filtra esa columna.
//   - filtro de fecha (type 'date-range'): valor 'DD/MM/YYYY~DD/MM/YYYY' (con rangeSeparator=~).
//   - `order[0][column]` = índice en `columns`, `order[0][dir]` = asc|desc.
//   - `start`/`length` = paginación. Respuesta: { recordsTotal, recordsFiltered, data:[...] }.
export async function fetchDataTable(resource, {
  view,
  baseFilter = null,
  columns = [],
  start = 0,
  length = 10,
  orderColumn = 0,
  orderDir = 'desc',
  globalSearch = '',
  columnSearch = {},
}) {
  const params = {
    draw: 1,
    start,
    length,
    'search[value]': globalSearch || '',
    'order[0][column]': orderColumn,
    'order[0][dir]': orderDir,
    rangeSeparator: '~',
  }
  if (view) params.view = view
  if (baseFilter) params.search = JSON.stringify(baseFilter)
  columns.forEach((c, i) => {
    params[`columns[${i}][data]`] = c.data
    params[`columns[${i}][search][value]`] = columnSearch[c.data] ?? ''
    params[`columns[${i}][type]`] = c.type || 'string'
  })
  const { data } = await api.get(`/${resource}/datatables`, { params })
  return {
    rows: data.data || data.list || [],
    recordsTotal: data.recordsTotal ?? 0,
    recordsFiltered: data.recordsFiltered ?? (data.data?.length ?? 0),
  }
}

// 'YYYY-MM-DD' (input date) -> 'DD/MM/YYYY' (formato de filtro Qualita).
export function toDDMMYYYY(ymd) {
  if (!ymd) return ''
  const [y, m, d] = ymd.split('-')
  return d && m && y ? `${d}/${m}/${y}` : ''
}
